import React from 'react';
import { Link } from 'react-router-dom';

// Circular collection story navigator (Instagram-style)
const COLLECTIONS = [
  { slug: 'kokten-isiga', name: 'Kökten Işığa', year: '2025', accent: '#8B7355', poster: 'https://customer-assets-cm19k8pv.emergentagent.net/job_3f3acde8-bbff-4f28-a1ca-d72be186d0f6/artifacts/yre7q9yc_KI.png' },
  { slug: 'turk-motifleri', name: 'Türk Motifleri', year: '2026', accent: '#2E86AB', poster: 'https://customer-assets-cm19k8pv.emergentagent.net/job_3f3acde8-bbff-4f28-a1ca-d72be186d0f6/artifacts/3uga6a0c_TM%20Afis%CC%A76.png' },
  { slug: 'yaz-masali', name: 'Yaz Masalı', year: '2026', accent: '#E4A853', poster: 'https://customer-assets-cm19k8pv.emergentagent.net/job_3f3acde8-bbff-4f28-a1ca-d72be186d0f6/artifacts/n60bnjxu_1.webp' },
  { slug: 'sakli-bahce', name: 'Saklı Bahçe', year: '2026', accent: '#4A7C59', poster: 'https://customer-assets-cm19k8pv.emergentagent.net/job_3f3acde8-bbff-4f28-a1ca-d72be186d0f6/artifacts/9uhugh6k_Sakl%C4%B1%20Bahc%CC%A7e%20.png' },
  { slug: 'goc', name: 'Göç', year: '2026', accent: '#8B4A6B', poster: 'https://customer-assets-cm19k8pv.emergentagent.net/job_3f3acde8-bbff-4f28-a1ca-d72be186d0f6/artifacts/1mbqa4fp_Go%CC%88c%CC%A7%20Afis%CC%A7.png' },
  { slug: 'nazende', name: 'Nazende', year: '2026', accent: '#B08D57', poster: 'https://customer-assets-cm19k8pv.emergentagent.net/job_3f3acde8-bbff-4f28-a1ca-d72be186d0f6/artifacts/qgsdb3qn_nazende.png' },
];

const CollectionStoryCircles = ({ activeSlug, onSelectAll }) => {
  return (
    <section className="pb-8 border-b border-gray-100" data-testid="collection-stories">
      <div className="flex items-baseline gap-3 mb-6">
        <div className="h-px flex-1 bg-gray-200" />
        <div className="text-[10px] tracking-[0.5em] text-gray-500 font-medium">— HİKÂYELER —</div>
        <div className="h-px flex-1 bg-gray-200" />
      </div>

      <div className="flex items-start gap-5 md:gap-8 overflow-x-auto no-scrollbar px-2 pb-2">
        {/* Tümü / All */}
        <button
          onClick={onSelectAll}
          className="flex flex-col items-center flex-shrink-0 group"
          data-testid="story-circle-all"
        >
          <div className={`relative w-20 h-20 md:w-24 md:h-24 rounded-full p-[3px] transition-all group-hover:scale-110 duration-500 ${
            activeSlug === 'all' || !activeSlug ? 'bg-gradient-to-br from-amber-400 via-rose-400 to-purple-500' : 'bg-gradient-to-br from-gray-200 to-gray-300 group-hover:from-amber-300 group-hover:to-rose-400'
          }`}>
            <div className="w-full h-full rounded-full bg-white p-[3px]">
              <div className="w-full h-full rounded-full overflow-hidden">
                <img
                  src="https://customer-assets-cm19k8pv.emergentagent.net/job_3f3acde8-bbff-4f28-a1ca-d72be186d0f6/artifacts/6bz19s82_Valmera%20Logo%20%281%29.png"
                  alt="Valméra"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
            {(activeSlug === 'all' || !activeSlug) && (
              <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 rounded-full bg-black border-2 border-white" />
            )}
          </div>
          <div className="mt-3 text-xs tracking-wider text-gray-700 font-medium group-hover:text-black">
            Tümü
          </div>
        </button>

        {/* Collection circles */}
        {COLLECTIONS.map((c) => (
          <Link
            key={c.slug}
            to={`/urunler?collection=${c.slug}`}
            className="flex flex-col items-center flex-shrink-0 group"
            data-testid={`story-circle-${c.slug}`}
          >
            <div className={`relative w-20 h-20 md:w-24 md:h-24 rounded-full p-[3px] transition-all group-hover:scale-110 duration-500 ${
              activeSlug === c.slug ? 'bg-gradient-to-br from-amber-400 via-rose-400 to-purple-500' : 'bg-gradient-to-br from-gray-200 to-gray-300 group-hover:from-amber-300 group-hover:to-rose-400'
            }`}>
              <div className="w-full h-full rounded-full bg-white p-[3px]">
                <div className="w-full h-full rounded-full overflow-hidden" style={{ backgroundColor: c.accent + '22' }}>
                  {c.poster ? (
                    <img src={c.poster} alt={c.name} className="w-full h-full object-cover" />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center" style={{
                      background: `linear-gradient(135deg, ${c.accent}66, ${c.accent}22)`
                    }}>
                      <span className="font-serif italic text-2xl" style={{ color: c.accent }}>{c.name[0]}</span>
                    </div>
                  )}
                </div>
              </div>
              {/* Live indicator dot */}
              {activeSlug === c.slug && (
                <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-2 h-2 rounded-full bg-black border-2 border-white" />
              )}
            </div>
            <div className={`mt-3 text-xs tracking-wider font-medium max-w-[100px] text-center leading-tight ${
              activeSlug === c.slug ? 'text-black font-semibold' : 'text-gray-700 group-hover:text-black'
            }`}>
              {c.name}
            </div>
            <div className="text-[10px] text-gray-400 mt-0.5">{c.year}</div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default CollectionStoryCircles;
